import { transformBranchIndicatorsReportToTableData } from './transformBranchIndicatorsReportToTableData';

export { transformBranchIndicatorsReportToTableData };
